<template>
  <div id="app">
    <div class="container-fluid app-container">
      <router-view @showLanguage="showLanguage"/>
 
    </div>
    <language ref="languageRef"></language>
  </div>
</template>
<script>
import language from './components/common/language.vue';
export default {
  components:{language},

  mounted () {
    window.addEventListener('unload', this.saveState);

     window.addEventListener("load", () => {
      sessionStorage.clear();
    })
  },
  methods: {
    showLanguage(){
      this.$refs.languageRef.selLanguage()
    },
    saveState () {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    }
  }
}
</script>
<style lang="less">
</style>
